import { render, staticRenderFns } from "./DateSelector.vue?vue&type=template&id=5b244edc"
import script from "./DateSelector.vue?vue&type=script&lang=js"
export * from "./DateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports